import { type FeatureSettingPath, isFeatureOrParentEnabled } from "@/config/features";
import type { ReactNode } from "react";

interface FeatureGuardProps {
  feature: FeatureSettingPath;
  children: ReactNode;
}

/**
 * Guard component that conditionally renders children based on feature settings
 */
export const FeatureGuard = ({ feature, children }: FeatureGuardProps) => {
  if (!isFeatureOrParentEnabled(feature)) {
    return null;
  }

  return <>{children}</>;
};
